// extracted by mini-css-extract-plugin
export default {"main__02":"ShoppingCart_main__02__mrNvv"};